import { useGetThemes, useReorderThemes } from '@/api/glow-up/glow-up.hooks';

import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { SortableList } from '@/components/ui/sortable-list';
import { ThemeCard } from './ThemeCard';

type ListProps = {
  refetch: () => void;
};

export const ThemeList = ({ refetch }: ListProps) => {
  const { themes, isLoading, isError } = useGetThemes({ skip: 0, take: 1000 });
  const reorder = useReorderThemes();

  if (isLoading) return <LoadingScreen />;
  if (isError) return <ErrorScreen />;

  if (themes.length === 0) {
    return (
      <p className="text-center text-muted-foreground py-8">
        Aucun thème pour le moment.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <SortableList
        items={themes}
        renderItem={(theme) => (
          <div className="flex flex-wrap gap-4 py-1">
            <ThemeCard theme={theme} refetch={refetch} />
          </div>
        )}
        onReorder={(items) => reorder.mutate(items)}
      />
    </div>
  );
};
